<template>
    <div>
        <div class="row" v-if="event">
            <div class="col-12">
                <RegisterForm v-bind="event" entity="event"  @on-pool="gotParticipants" :withSubmit="event.isOpen"  :showSubmit="true"></RegisterForm>
            </div>
        </div>
        <div class="row justify-content-center mt-5" v-else>
            <div class="col-md-6">
                <h1 class="text-white" style="margin-bottom: 0;"><strong>Loading...</strong></h1>
                <h2 class="text-white">We are fetching the details for you. It'll be just a moment.</h2>
            </div>
        </div>
        
    </div>
</template>

<script>
import { RegisterForm } from 'src/components';
import { mapGetters } from 'vuex';

export default {
    name: 'RegisterEvent',
    components:{
        RegisterForm,
    },
    mounted(){
        this.$store.commit('setEvent', null)
        this.$store.dispatch('getEvent', this.$route.params.slug)
    },
    computed: {
        ...mapGetters({
            event: 'getEvent',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences'
        }),
    },
    methods: {
        gotParticipants(pool){
            // Note:- Work around for this.programme.participants_pool = pool
            // Vue is not reactive for such changes
            // https://vuejs.org/v2/guide/list.html#Object-Change-Detection-Caveats
            // Vue does not allow dynamically adding new root-level reactive properties to an already created instance.
            // However, it’s possible to add reactive properties to a nested object using the Vue.set(object, propertyName, value) 
            this.$set(this.event, 'participants_pool', pool)
        }
    }
}
</script>

<style>

</style>
